import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { VocabularySharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-vocabulary',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './vocabulary.component.html',
    styleUrls: ['./vocabulary.component.scss'],
    standalone: false
})
export class VocabularyComponent {
  /**
   * Inputs
   */
  @Input() public vocabulary: FlatModels.PageEntityModels.Vocabulary;

  /**
   * Members
   */
  public currentChar = '';
  public filter = '';

  /**
   * Constructor
   *
   * @param ref
   * @param vocabularyViewerFacade
   */
  public constructor(public ref: ChangeDetectorRef,
                     public vocabularyViewerFacade: VocabularySharedFacade) {
  }

  /**
   * Get Current Char
   *
   * @param vocabularyWord
   */
  public getCurrentChar(vocabularyWord: FlatModels.VocabularyWordEntityModels.VocabularyWord) {
    const firstLetter = vocabularyWord.key[0].toUpperCase();
    if (firstLetter !== this.currentChar) {
      this.currentChar = firstLetter;
      return firstLetter;
    }
    return undefined;
  }

  /**
   * Set Filter
   *
   * @param filter
   */
  public setFilter(filter: string) {
    this.filter = filter.trim().toLowerCase();
    this.ref.detectChanges();
  }

  /**
   * Filter Vocabulary Words
   *
   * @param vocabularyWords
   */
  public filterVocabularyWords(vocabularyWords: FlatModels.VocabularyWordEntityModels.VocabularyWord[]) {
    return vocabularyWords.filter(vocabularyWord => `${vocabularyWord.key} ${vocabularyWord.value}`.toLowerCase().includes(this.filter));
  }
}
